import axios from "axios";
import {
  SUBCATEGORIES_CREATE_REQUEST,
  SUBCATEGORIES_CREATE_SUCCESS,
  SUBCATEGORIES_CREATE_FAIL,
  ALL_SUBCATEGORIES_VIEW_REQUEST,
  ALL_SUBCATEGORIES_VIEW_SUCCESS,
  ALL_SUBCATEGORIES_VIEW_FAIL,
  SUBCATEGORY_UPDATE_REQUEST,
  SUBCATEGORY_UPDATE_SUCCESS,
  SUBCATEGORY_UPDATE_FAIL,
  GROUP_SUBCATEGORIES_VIEW_REQUEST,
  GROUP_SUBCATEGORIES_VIEW_SUCCESS,
  GROUP_SUBCATEGORIES_VIEW_FAIL,
  SERVERADDRESS,
} from "../constants";
// import { notifyFailure, notifySuccess } from "../components/toast";

export const createSubCategories =
  (obj, callback, setReservationId) => async (dispatch) => {
    dispatch({
      type: SUBCATEGORIES_CREATE_REQUEST,
    });
    try {
      const { data } = await axios.post(
        `${SERVERADDRESS}/v1/subCategories/createSubCategories`,
        obj
      );
      dispatch({
        type: SUBCATEGORIES_CREATE_SUCCESS,
        payload: data,
      });
      callback && callback(data.id);
    } catch (err) {
      //   notifyFailure(err.response.data.message);
      dispatch({
        type: SUBCATEGORIES_CREATE_FAIL,
        payload: err,
      });
    }
  };

export const getAllSubCategories = (obj, callback) => async (dispatch) => {
  dispatch({
    type: ALL_SUBCATEGORIES_VIEW_REQUEST,
  });
  try {
    const { data } = await axios.get(
      `${SERVERADDRESS}/v1/subCategories/getAllSubCategories`,
      obj
    );

    localStorage.setItem("subCategories", JSON.stringify(data));
    console.log(data, "data");

    dispatch({
      type: ALL_SUBCATEGORIES_VIEW_SUCCESS,
      payload: data,
    });
  } catch (err) {
    console.log(err);
    dispatch({
      type: ALL_SUBCATEGORIES_VIEW_FAIL,
      payload: err,
    });
  }
};

export const updateSubCategoriesById =
  (obj, handleSuccess) => async (dispatch) => {
    dispatch({
      type: SUBCATEGORY_UPDATE_REQUEST,
    });
    try {
      const { data } = await axios.patch(
        `${SERVERADDRESS}/v1/subcategories/updateSubCategoriesById`,
        obj
      );
      handleSuccess();
      // notifySuccess("Updated successfully !");
      dispatch({
        type: SUBCATEGORY_UPDATE_SUCCESS,
        payload: data,
      });
    } catch (err) {
      // console.log(err);
      // notifyFailure(err?.response?.data?.message);
      dispatch({
        type: SUBCATEGORY_UPDATE_FAIL,
        payload: err,
      });
    }
  };

export const groupSubCategories = (obj, callback) => async (dispatch) => {
  dispatch({
    type: GROUP_SUBCATEGORIES_VIEW_REQUEST,
  });
  try {
    const { data } = await axios.get(
      `${SERVERADDRESS}/v1/subCategories/groupSubCategories`,
      obj
    );

    localStorage.setItem("groupSubCategories", JSON.stringify(data));
    console.log(data, "data");

    dispatch({
      type: GROUP_SUBCATEGORIES_VIEW_SUCCESS,
      payload: data,
    });
  } catch (err) {
    console.log(err);
    dispatch({
      type: GROUP_SUBCATEGORIES_VIEW_FAIL,
      payload: err,
    });
  }
};
